module.exports = __webpack_public_path__ + "img/location.dbd3ab54.png";